module.exports = __webpack_public_path__ + "img/wb_o_office-galway.ceab9826.svg";